import { Directive, HostListener, ElementRef } from '@angular/core';

import { DownloadService } from '../../_services/download.service';

@Directive({
  selector: '[appDownload]'
})
export class DownloadDirective {

  constructor(
    private el: ElementRef,
    private downloadService: DownloadService
  ) { }


  @HostListener('click', ['$event.target']) onClick(btn) {
    if (btn.dataset.file) {
      this.downloadService.downloadSecureFile(btn.dataset.file, btn.dataset.type || 'zip', btn.dataset.filename).subscribe(result => {
        console.log('sssss', result)
      }, (error) => {
        console.log('error', error);
      });
    }

 }





}
